import React, { ReactElement, useContext } from 'react'
import { Popper, PopperPlacementType, Fade } from '@material-ui/core'
import ModalExitPromptContext, { ModalExitPromptType } from '../Modal/ModalExitPromptContext'

export type PopperProps = {
    content: ReactElement
    open: boolean
    anchorEl: Nullable<HTMLElement>
    placement: PopperPlacementType
    infoMode?: boolean
    className?: string
    onMouseOver?: () => void
    onMouseOut?: () => void
}

/**
 * A generic confirmation popper component allowing custom content within it.
 * @param content HTML content inside of the popper.
 * @param open Open react state flag.
 * @param anchorEl Element this popper should be relative to.
 * @param placement Position of the popper.
 * @param infoMode - Use the white colours.
 * @param className Class assigned to popper element.
 */
const PopperBubble: React.FC<PopperProps> = ({
    content,
    open,
    anchorEl,
    placement,
    infoMode,
    className,
    onMouseOut,
    onMouseOver
}: PopperProps): ReactElement => {
    const modalExitPromptContext: ModalExitPromptType = useContext(ModalExitPromptContext)

    const setPosition = (): string => {
        switch (placement) {
            case 'top':
                return 'top'
            case 'bottom':
                return 'bottom'
            default:
                return 'top'
        }
    }

    return (
        <Popper
            className={`details-popper-container ${setPosition()} ${className}`}
            open={!modalExitPromptContext?.isExitPromptDisplayed && open}
            anchorEl={anchorEl}
            placement={placement}
            transition={!modalExitPromptContext?.isExitPromptDisplayed}
            onMouseOver={onMouseOver}
            onMouseOut={onMouseOut}
        >
            {({ TransitionProps }): ReactElement => (
                <Fade {...TransitionProps} timeout={350}>
                    <div className={`details-popper ${infoMode ? 'info-mode' : ''}`}>{content}</div>
                </Fade>
            )}
        </Popper>
    )
}

export default PopperBubble
